import React from "react";
import { Box } from "@mui/material";

import CompanyArticlesSection from "./DetailSections/CompanyArticlesSection";
import CompanyCompetitorsSection from "./DetailSections/CompanyCompetitorsSection";
import CompanyDocuments from "./DetailSections/CompanyDocuments";
import CompanyInformationSection from "./DetailSections/CompanyInformationSection";
import CompanyDescriptionSection from "./DetailSections/CompanyDescriptionSection";

const CompanyDetailsTabContent = ({
  company = {},
  companyId = null,
  leadId = null,
  entityType = "lead",
  onCompanyChange,
  fieldOptions = {},
}) => {
  return (
    <>
      <Box id="company-details-information">
        <CompanyInformationSection
          company={company}
          leadId={leadId}
          entityType={entityType}
          onCompanyChange={onCompanyChange}
          fieldOptions={fieldOptions}
        />
      </Box>

      <Box id="company-details-description">
        <CompanyDescriptionSection
          leadId={leadId}
          companyId={companyId || company.id}
          entityType={entityType}
          onCompanyChange={onCompanyChange}
          companyProfileEnrichmentPending={company.company_profile_enrichment_pending}
          elevatorPitch={company.elevator_pitch || ""}
          fullDescription={company.full_company_description || ""}
          missionVision={company.mission_and_vision || ""}
          keyProducts={company.key_products_services || ""}
          usp={company.unique_selling_points || ""}
          perks={company.employee_perks || ""}
          achievements={company.achievements_awards || ""}
          techStack={
            Array.isArray(company.recruitment_tools)
              ? company.recruitment_tools
              : Array.isArray(company.techStack)
              ? company.techStack
              : []
          }
        />
      </Box>

      <Box id="company-details-articles">
        <CompanyArticlesSection companyId={companyId || company.id} />
      </Box>

      <Box id="company-details-competitors">
        <CompanyCompetitorsSection
          leadId={leadId}
          companyId={companyId || company.id}
          entityType={entityType}
          companyProfileEnrichmentPending={company.company_profile_enrichment_pending}
        />
      </Box>

      <Box id="company-details-documents">
        <CompanyDocuments
          company={company}
          companyId={companyId || company.id}
          entityType={entityType}
          onCompanyChange={onCompanyChange}
        />
      </Box>
    </>
  );
};

export default CompanyDetailsTabContent;
